import { internalTraffic } from './campaignAttribution';
// Reddit runs in a sandbox with no access to the account, library or prompts.
export const ADS_CONSENT_KEY = 'sonikly.reddit-measurement.v1';
export const adsChoice = () => { try { return localStorage.getItem(ADS_CONSENT_KEY); } catch { return null; } };
export const adsAllowed = () => adsChoice() === 'accepted' && !internalTraffic() && navigator.globalPrivacyControl !== true && navigator.doNotTrack !== '1' && window.location.pathname !== '/reset-password';
export const redditLanding = () => new URLSearchParams(window.location.search).get('utm_source') === 'reddit';
let frame;
let ready = false;
let queue = [];
let lastPage;
const CLICK_KEY = 'sonikly.reddit-click.v1';
const events = new Set(['PageVisit', 'SignUp', 'Lead']);
function flush() {
  if (!ready || !adsAllowed()) return;
  queue.splice(0).forEach((event) => frame?.contentWindow?.postMessage({ type: 'sonikly-ad-event', event }, '*'));
}
export function startRedditAds() {
  if (!adsAllowed() || frame || !['sonikly.ai', 'www.sonikly.ai'].includes(window.location.hostname)) return false;
  frame = document.createElement('iframe');
  frame.title = 'Optional advertising measurement';
  frame.hidden = true;
  frame.setAttribute('sandbox', 'allow-scripts');
  frame.referrerPolicy = 'no-referrer';
  frame.dataset.soniklyReddit = 'true';
  const url = new URL('/reddit-measurement.html', window.location.origin);
  // The ad click ID is the only URL parameter supplied to Reddit. Never forward the page URL.
  let click = new URLSearchParams(window.location.search).get('rdt_cid');
  try {
    if (click && /^[a-zA-Z0-9_-]{1,200}$/.test(click)) localStorage.setItem(CLICK_KEY, JSON.stringify({click, until: Date.now() + 7 * 86400000}));
    else {
      const saved = JSON.parse(localStorage.getItem(CLICK_KEY) || 'null');
      click = saved?.until > Date.now() ? saved.click : null;
      if (!click) localStorage.removeItem(CLICK_KEY);
    }
  } catch { click = null; }
  if (click && /^[a-zA-Z0-9_-]{1,200}$/.test(click)) url.searchParams.set('rdt_cid', click);
  frame.src = url.href;
  document.body.appendChild(frame);
  return true;
}
window.addEventListener('message', (message) => {
  if (frame && message.source === frame.contentWindow && message.data?.type === 'sonikly-ad-delivered' && events.has(message.data.event)) {
    frame.dataset.lastDeliveredEvent = message.data.event;
    frame.setAttribute(`data-delivered-${message.data.event.toLowerCase()}`, 'true');
  }
  if (frame && message.source === frame.contentWindow && message.data?.type === 'sonikly-ad-ready') {
    ready = true;
    flush();
  }
});
export function chooseAds(choice) {
  try { localStorage.setItem(ADS_CONSENT_KEY, choice); } catch { return; }
  if (choice === 'accepted') { startRedditAds(); trackRedditPageView(); }
  else { frame?.remove(); frame = undefined; ready = false; queue = []; lastPage = undefined; try { localStorage.removeItem(CLICK_KEY); } catch {} }
}
export function trackRedditPageView() {
  if (!adsAllowed() || lastPage === window.location.pathname) return false;
  if (!trackRedditEvent('PageVisit')) return false;
  lastPage = window.location.pathname;
  return true;
}
export function trackRedditEvent(event, dedupeKey) {
  if (!events.has(event) || !adsAllowed()) return false;
  if (dedupeKey) {
    try {
      const key = `sonikly.ad-sent.${event}.${dedupeKey}`;
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
    } catch { return false; }
  }
  startRedditAds();
  if (!frame) return false;
  queue.push(event);
  flush();
  return true;
}
